<template>
  <div>
    <v-text-field
      v-model="search"
      label="Buscar medicamento..."
      prepend-inner-icon="mdi-magnify"
      outlined
      dense
      clearable
      :loading="searching"
      @input="onSearchInput"
    ></v-text-field>

    <!-- Resultados da busca -->
    <div
      v-if="results.length > 0"
      class="med-results mb-3 pa-3 rounded-lg"
      style="background: #f5f5f5"
    >
      <p class="caption grey--text text--darken-1 mb-2 font-weight-medium">
        Resultados — clique para adicionar:
      </p>
      <v-chip
        v-for="(med, index) in results"
        :key="index"
        class="ma-1"
        outlined
        color="green darken-2"
        small
        :disabled="isSelected(med)"
        @click="add(med)"
      >
        <v-icon left x-small>
          {{ isSelected(med) ? "mdi-check" : "mdi-plus" }}
        </v-icon>
        {{ med.label }}
      </v-chip>
    </div>
    <p
      v-else-if="search && search.length >= 2 && !searching"
      class="caption grey--text"
    >
      <v-icon small color="grey" class="mr-1">mdi-alert-circle-outline</v-icon>
      Nenhum medicamento encontrado
    </p>
    <p
      v-else-if="search && search.length < 2 && !searching"
      class="caption grey--text"
    >
      Digite ao menos 2 caracteres para buscar
    </p>

    <!-- Selecionados -->
    <div
      v-if="model.length > 0"
      class="mt-3 pa-3 rounded-lg"
      style="background: #f0fdf4"
    >
      <p class="caption font-weight-medium mb-2" style="color: #15803d">
        <v-icon small color="catGreen" class="mr-1">mdi-check-circle</v-icon>
        Selecionados:
      </p>
      <v-chip
        v-for="(med, index) in model"
        :key="'sel-' + index"
        class="ma-1"
        color="catGreen"
        text-color="white"
        small
        close
        @click:close="remove(index)"
      >
        <span class="ds-chip-label" :title="med.label">{{ med.label }}</span>
      </v-chip>
    </div>
    <v-alert
      v-if="model.length === 0"
      type="info"
      dense
      text
      class="mt-3 rounded-lg"
      icon="mdi-information-outline"
      color="catGreen"
    >
      Pesquise e adicione ao menos um medicamento
    </v-alert>
  </div>
</template>

<script>
import { searchMedications } from "@/services/patientMedicationService";

export default {
  name: "MedicationSearchField",

  props: {
    // Array de objetos de medicamento já selecionados
    value: { type: Array, default: () => [] },
  },

  data() {
    return {
      search: "",
      results: [],
      searching: false,
      debounceTimer: null,
    };
  },

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  beforeDestroy() {
    clearTimeout(this.debounceTimer);
  },

  methods: {
    onSearchInput() {
      clearTimeout(this.debounceTimer);
      if (!this.search || this.search.length < 2) {
        this.results = [];
        return;
      }
      this.debounceTimer = setTimeout(() => this.runSearch(), 400);
    },

    async runSearch() {
      this.searching = true;
      try {
        this.results = await searchMedications(this.search);
      } catch (err) {
        console.error("Erro ao buscar medicamento:", err);
        this.results = [];
      } finally {
        this.searching = false;
      }
    },

    // Identidade de uma variante = nome + dosagem + apresentação (o `label` já junta
    // os três). É o que distingue linhas de mesmo nome mas dosagens diferentes —
    // assim dá para escolher "Losartana 50mg" E "Losartana 100mg".
    medKey(med) {
      return (
        med.label ||
        [med.name, med.dosage, med.presentation].filter(Boolean).join(" — ")
      ).toLowerCase();
    },

    isSelected(med) {
      return this.model.some((m) => this.medKey(m) === this.medKey(med));
    },

    add(med) {
      if (!this.isSelected(med)) {
        this.$emit("input", [...this.model, med]);
      }
    },

    remove(index) {
      const next = this.model.slice();
      next.splice(index, 1);
      this.$emit("input", next);
    },
  },
};
</script>

<style scoped>
.med-results {
  max-height: 220px;
  overflow-y: auto;
}
</style>
